/* Hendy — zwevende header: eigen scroll-detectie.
   Dawn's eigen 'scrolled-past-header'-klasse leunt op een IntersectionObserver-
   meting van de header-hoogte die niet klopt door onze negatieve marge-truc
   (het zwevende-header-effect) — daardoor triggerde 'ie nooit. Dit is simpeler
   en werkt onafhankelijk daarvan: gewoon de scrollpositie, geen library. */
(function () {
  var body = document.body;
  if (!body.classList.contains('hendy-floating')) return;

  var THRESHOLD = 40;
  function onScroll() {
    body.classList.toggle('hy-scrolled', window.scrollY > THRESHOLD);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
